export const HOME_URL = 'https://scan.aura.com';

export const AURA_URL = 'https://www.aura.com/';
export const LEGAL_URL = 'https://www.aura.com/legal';
export const HELP_URL = 'https://www.aura.com/help';
export const PRIVACY_POLICY_URL = 'https://www.aura.com/legal/privacy-policy';
export const TERMS_OF_SERVICE_URL = 'https://www.aura.com/legal/service-terms';
export const YOUR_PRIVACY_CHOICES_URL =
  'https://www.aura.com/legal/your-privacy-choices';
export const INSURANCE_SUMMARY_OF_BENEFITS_URL =
  'https://www.aura.com/legal/insurance-summary-of-benefits';
export const FBI_REPORT_URL =
  'https://www.ic3.gov/Media/PDF/AnnualReport/2023_IC3Report.pdf';
export const AURA_YOUTUBE_VIDEO_URL =
  'https://www.youtube.com/embed/7-lDRgxbU1Y?si=6WyqnWI4BwBHluvO&controls=1&autoplay=1';
export const AURA_WEBSITE_CONSENT_URL =
  'https://www.aura.com/legal/website-terms#5.-Mobile-Network-Operator-(MNO)-Consent';
export const AURA_PRICING_URL = 'https://buy.aura.com/privacy';
export const AURA_RISK_REPORT_OFFER = 'https://www.aura.com/risk-report-offer';
